import React, {useEffect} from 'react';
import Stack from "@mui/material/Stack";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import AuthUserDropdown from "../../../../shared/widgets/AuthUserDropdown";
import NotificationsDropdown from "../../../../shared/NotificationsDropdown";
import MessagesDropdown from "../../../../shared/MessagesDropdown";
import SearchGlobal from "../../../../shared/SearchGlobal";
import {IconButton, Slide, useMediaQuery} from "@mui/material";
import Div from "@jumbo/shared/Div";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import JumboIconButton from "@jumbo/components/JumboIconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logo from "../../../../shared/Logo";
import {SIDEBAR_STYLES, SIDEBAR_VARIANTS} from "@jumbo/utils/constants";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import {useDispatch, useSelector} from "react-redux";
import {
    ListEmployee, CreditUser, gettransactionuser, GetProfile

} from "../../../../../api/api";
import {savecredit, savename, saveadmin, saveemail, savelogo} from "../../../../redux/actions/contactsApp";


function toPersianNum(num, dontTrim) {

    if (num === '') {
        return '';
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};
const Header = () => {
    const {sidebarOptions, setSidebarOptions} = useJumboLayoutSidebar();
    const [dropdownSearchVisibility, setDropdownSearchVisibility] = React.useState(false);
    // const [credit, setCredit] = React.useState(100000000);
    const {headerTheme} = useJumboHeaderTheme();
    const {credit} = useSelector(({contactsApp}) => contactsApp);
    const dispatch = useDispatch();

    const showDropdownSearch = useMediaQuery('(max-width:575px)');


    useEffect(() => {

        let tk = localStorage.getItem('token');

        if (tk === "" || tk === null) {


        } else {

            CreditUser()
                .then((response) => {

                    dispatch(savecredit(response.data.credit));


                })
                .catch((error) => {


                });

            GetProfile()
                .then((response) => {

                    dispatch(savename(response.data.profile.companyname));
                    dispatch(saveemail(response.data.profile.email));
                    dispatch(savelogo(response.data.profile.logo));
                    if (response.data.profile.type === 2) {
                        dispatch(saveadmin(true));
                    } else {
                        dispatch(saveadmin(false));
                    }

                })
                .catch((error) => {


                });


        }
    }, []);


    return (
        <React.Fragment>
            {
                (
                    sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER
                    || sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY
                    || (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT && !sidebarOptions.open)
                ) &&
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    sx={{
                        ml: sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ? -2 : 0,
                        mr: 3,
                    }}
                    onClick={() => setSidebarOptions({open: !sidebarOptions.open})}
                >
                    {
                        sidebarOptions?.open ? <MenuOpenIcon/> : <MenuIcon/>
                    }
                </IconButton>
            }
            {
                sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER &&
                <Logo sx={{mr: 3}} mode={headerTheme.type ?? "light"}/>
            }
            {
                showDropdownSearch &&
                <Slide in={dropdownSearchVisibility}>
                    <Div
                        sx={{
                            zIndex: 5,
                            left: 0,
                            right: 0,
                            position: 'absolute',
                            height: '100%',
                        }}
                    >
                        <SearchGlobal
                            sx={{
                                maxWidth: 'none',
                                height: '100%',
                                display: 'flex',

                                '& .MuiInputBase-root': {
                                    flex: 1,
                                    borderRadius: 0,
                                    background: theme => theme.palette.background.default,
                                },
                                '& .MuiInputBase-input': {
                                    pr: 6,
                                }
                            }}
                        />
                        <IconButton
                            sx={{
                                position: 'absolute',
                                right: 15,
                                top: '50%',
                                color: 'inherit',
                                transform: 'translateY(-50%)',
                            }}
                            onClick={() => setDropdownSearchVisibility(false)}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </Div>
                </Slide>
            }
            {/*{*/}
            {/*    !showDropdownSearch &&*/}
            {/*    <SearchGlobal*/}
            {/*        sx={{*/}
            {/*            maxWidth: {xs: 240, md: 320}*/}
            {/*        }}*/}
            {/*    />*/}
            {/*}*/}
            <Stack direction="row" alignItems="center" spacing={1.25} sx={{ml: "auto"}}>
                {
                    showDropdownSearch &&
                    <JumboIconButton elevation={25} onClick={() => setDropdownSearchVisibility(true)}>
                        <SearchIcon fontSize={"small"}/>
                    </JumboIconButton>
                }

                <Div sx={{display: 'none'}} lx={{display: 'show'}}>


                </Div>

                {sidebarOptions.open ?

                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <div style={{marginLeft: 10, fontSize: 15, fontFamily: 'Iran', fontWeight: 'bold'}}> مانده حساب

                        </div>
                        <div style={{marginLeft: 25, fontSize: 15, fontFamily: 'Iran', fontWeight: 'bold'}}>
                            {toPersianNum(Number(credit).toLocaleString())} تومان
                        </div>

                    </div>


                    :

                    null
                }


                {/*<MessagesDropdown/>*/}
                {/*<NotificationsDropdown/>*/}
                <AuthUserDropdown/>
            </Stack>
        </React.Fragment>
    );
};

export default Header;
